module.exports = {"430626100":"汉昌镇","430626101":"安定镇","430626102":"三市镇","430626103":"加义镇","430626104":"长寿镇","430626105":"龙门镇","430626106":"虹桥镇","430626107":"南江镇","430626108":"梅仙镇","430626109":"浯口镇","430626110":"瓮江镇","430626111":"伍市镇","430626112":"向家镇","430626113":"童市镇","430626114":"岑川镇","430626115":"福寿山镇","430626116":"余坪镇","430626117":"石牛寨镇","430626118":"上塔市镇","430626200":"三阳乡","430626205":"木金乡","430626208":"板江乡","430626209":"大洲乡","430626210":"三墩乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430626.json
// module id = 1866
// module chunks = 0